"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpressPriceDTO = void 0;
const class_validator_1 = require("class-validator");
const PriceDTO_1 = require("./PriceDTO");
const IsNullable_1 = require("../../transformation/IsNullable");
class ExpressPriceDTO extends PriceDTO_1.PriceDTO {
}
exports.ExpressPriceDTO = ExpressPriceDTO;
__decorate([
    (0, class_validator_1.IsNumber)({ allowNaN: false, allowInfinity: false, maxDecimalPlaces: 3 }),
    (0, class_validator_1.Min)(0),
    (0, IsNullable_1.IsNullable)(),
    __metadata("design:type", Number)
], ExpressPriceDTO.prototype, "expressPrice", void 0);
